<template>
  <component
    :is="wrapperElementType"
    :class="wrapperCssClasses">
    <component
      :is="wrapperElementType"
      :aria-live="ariaLive"
      :class="overlayCssClasses"
    >
      <slot name="loadingIcon">
        <template v-if="isLoading">
          <LoadingSpinner
            width="1em"
            height="1em"
            :title="loadingMessage"
            :class="iconCssClasses"
          />
        </template>
      </slot>
    </component>

    <component
      :is="wrapperElementType"
      :class="slotWrapperCssClasses"
      :aria-busy="isLoading"
    >
      <slot name="default">
        <!-- remember to set aria-busy=[boolean] attribute on slotted content, where boolean mirrors isLoading, to maximise SR compatibility. -->
      </slot>
    </component>
  </component>
</template>

<script>
import LoadingSpinner from './LoadingSpinner.vue'

export default {
  name: 'LoadingOverlay',
  components: {
    LoadingSpinner,
  },
  props: {
    /** Whether the overlay is for block-level or inline content. */
    wrapperElementType: {
      type: String,
      default: 'div',
    },
    /** Controls loading state of the overlay */
    isLoading: {
      type: Boolean,
      default: false,
    },
    /** Choose announcement interruption type. */
    ariaLive: {
      type: String,
      default: 'polite',
      validator: (value) => {
        ['polite', 'assertive', 'off'].includes(value)
      },
    },
    /* Accessibility. Will be announced when inserted into live region. */
    loadingMessage: {
      type: String,
      default: 'Currently loading. Please wait.',
    },
    /** Reset default styles */
    customWrapperCssClasses: {
      type: Array,
      default: null,
    },
    /** Reset default styles */
    customOverlayCssClasses: {
      type: Array,
      default: null,
    },
    /** Reset default styles */
    customIconCssClasses: {
      type: Array,
      default: null,
    },
    /** Reset default styles */
    customSlotWrapperCssClasses: {
      type: Array,
      default: null,
    },
  },
  computed: {
    wrapperCssClasses() {
      return this.chooseClassList(this.customWrapperCssClasses, ['relative'])
    },
    overlayCssClasses() {
      const classes = [
        'motion-safe:transition-colors',
        'motion-safe:duration-500',
        'motion-safe:ease-in',
      ]
      const loadingStateClasses = [
        'absolute',
        'z-50',
        'inset-0',
        'flex',
        'justify-center',
        'bg-white',
        'bg-opacity-80',
      ]
      if (this.isLoading) classes.push(...loadingStateClasses)
      return this.chooseClassList(this.customOverlayCssClasses, classes)
    },
    iconCssClasses() {
      return this.chooseClassList(this.customIconCssClasses, [
        'sticky',
        'mt-[1em]',
        'top-[1em]',
        'text-[4em]',
        'lg:text-[8em]',
      ])
    },
    slotWrapperCssClasses() {
      const classes = []
      if (this.isLoading) classes.push('pointer-events-none')
      return this.chooseClassList(this.customSlotWrapperCssClasses, classes)
    },
  },
  methods: {
    chooseClassList(custom, standard) {
      if (Array.isArray(custom)) {
        return custom
      }
      else {
        return standard
      }
    },
  },
}
</script>
